import { Tooltip, TooltipProps } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import classes from './InfoTooltip.module.scss';

export const InfoTooltip = ({ children, title, ...props }: TooltipProps) => (
  <Tooltip title={title} placement="top-start" {...props}>
    <div className={classes.tooltip}>
      <InfoOutlined className="body" />
      {children}
    </div>
  </Tooltip>
);
